export default __webpack_public_path__ + "03c114f6e014588a4bde815d9bc85821.svg";